import { type AppThunk } from "features/Application/globaltypes/redux";
import { fetchBegin, fetchSuccess } from "../TemplateCustomersSlice";
import { type SortingDirection } from "enums";
import DataService from "features/Application/services/dataServices/typedDataService";
import backgroundTask from "features/BackgroundTasks/backgroundTask";
import { type UpdateParams } from "interfaces";

export const getCustomers =
  (
    id: number,
    skip: number,
    top: number,
    sortBy?: string,
    sortOrder?: SortingDirection,
    searchTerm?: string,
  ): AppThunk =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchBegin());

      const result = await DataService.groupTemplates.getCustomers(id, {
        top,
        skip,
        sortBy,
        sortOrder,
        term: searchTerm,
      });

      dispatch(
        fetchSuccess({
          items: result.data.items,
          totalCount: result.data.count,
        }),
      );
    } catch {}
  };

export const removeCustomers =
  (templateId: number, customerIds: number[]): AppThunk =>
  async (dispatch) => {
    const multi = customerIds.length > 1;
    try {
      const updateParams: UpdateParams = {
        id: "RemovingTramplteCustomers",
        title: `Removing customers`,
        getMessageIds: async () => {
          const { data } = await DataService.groupTemplates.removeCustomers(templateId, customerIds);
          return data.messageIds;
        },
        successTransientMessage: `${multi ? "Customers have" : "Customer has"} been removed from this template successfully.`,
        successTitle: `${multi ? "Customers" : "Customer"} removed!`,
        failureTransientMessage: `Removing customers failed!`,
      };

      await backgroundTask.initializeBackgroundTask(updateParams, dispatch);
    } catch {}
  };
